import useWeb3Ctx from "../../hooks/useWeb3Ctx";
import { ECAddress } from "ec-commons";
import { Box, Button, Typography } from "@mui/material";
import { fontFamily } from "@mui/system";
const BP1 = "@media (max-width: 999px)";
const BP5 = "@media (max-width: 500px)";

const sx = {
  root: {
    pt: '5px',
    display: 'flex',
    alignItems: 'center',
    [BP1]: {
      pt: "0",
    },
  },
  connectBtn: {
    ml: "50px",
    fontSize: "20px",
    borderRadius: "0px",
    minHeight: "65px",
    width: "130px",
    fontFamily: "boucherie-block",
    border: "2px solid #020100",
    backgroundColor: "#020100",
    backgroundClip: "content-box",
    padding: "5px",
    "&:hover": {
      border: "2px solid #9D4C10",
      backgroundColor: "#9D4C10",
    },
    "&:active": {
      border: "2px solid #6A330A",
      backgroundColor: "#6A330A",
    },
  },
  buttonText: {
    width: "100%",
    height: "100%",
    backgroundColor: "#030200",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px",
    fontFamily: "Boucherie-Block",
  },
  disconnectBtn: {
    textAlign: "center",
    cursor: "pointer",
    color: "#020100",
    transition: "color 0.3s ease-in-out",
    margin: 0,
    marginLeft: "-7px",
    fontSize: "0.8rem",
    fontWeight: "500",
    lineHeight: "0.3rem",
    marginTop: "-5px",
    ml: "50px",
    "&:hover": {
      color: "#9D4C10",
    },
  },
  address: {
    color: "#020100",
    zIndex: 1,
    minWidth: "150px",
    ml: "50px",
    [BP5]: {
      transform: "scale(0.9)",
    },
  },
  errorBtn: {
    textTransform: "uppercase",
    lineHeight: "1.75",
    color: "#020100",
    fontSize: "0.8rem",
    fontWeight: "500",
    padding: "5px 15px",
    minWidth: "150px",
    backgroundColor: "#FF1414",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    transition: "all .3s",
    textTransform: "unset",
    borderRadius: "8px",
    ml: "50px",
    "&:hover": {
      backgroundColor: "#FF1414",
      opacity: "0.8",
    },
  },
};

const ConnectWalletBtn = () => {
  const {
    handleConnect,
    handleDisconnect,
    isCorrectNetwork,
    address,
    walletCheck,
  } = useWeb3Ctx();

  return (
    <>
      <Box sx={sx.root}>
        {!address && (
          <Button variant="outlined" sx={sx.connectBtn} onClick={handleConnect}>
            Connect
          </Button>
        )}
        {address && isCorrectNetwork && (
          <Box sx={sx.address} onClick={(e) => e.stopPropagation()}>
            <ECAddress address={address} short blockie scale={5} />
            <Box sx={sx.disconnectBtn} onClick={() => handleDisconnect()}>
              disconnect
            </Box>
          </Box>
        )}
        {address && !isCorrectNetwork && (
          <Button sx={sx.errorBtn} onClick={walletCheck}>
            Wrong Network
          </Button>
        )}
      </Box>
    </>
  );
};

export default ConnectWalletBtn;
